import apiClient from '@/api/client';
import { useAuthStore } from '@/stores/authStore';
import { User } from '@/types/User';
import { useQuery } from '@tanstack/react-query';

export const getMe = async (): Promise<User> => {
  const response = await apiClient.get<User>('users/me/');
  if (response.data) {
    useAuthStore.setState({ user: response.data });
  }
  return response.data;
};

export const useMe = () => {
  return useQuery({
    queryKey: ['user', 'me'],
    queryFn: getMe,
    enabled: !!useAuthStore.getState().isAuthenticated,
  });
};
